import styled from "styled-components";


interface FilmStripItemProps {
    itemWidth: string
}

interface FilmStripProps extends FilmStripItemProps {
    action: string
    position: number
    transition: string
    gap: string
    windowSize: number
    amount: number

}

export const Container = styled.div`
  display: flex;
  flex-direction: column; /* PC default */
  width: 100vw; /* full viewport width */
  height: auto;
  //overflow-y: auto;
  overflow-x: hidden;

  justify-content: center; /* vertical center */
  align-items: center;     /* horizontal center */
  text-align: center;
  background: inherit;
  background-size: 100%auto;

`;


export const HorizontalDiv = styled.div`

  @media (max-width: 768px) {
    flex-direction: column; /* Mobile */
  }
  display: flex; /* makes children horizontal */
  gap: 10px; /* spacing between items */
  padding: 10px;
  align-items: center;
  justify-content: center;
`

export const Box = styled.div<{ visible: boolean }>`
  display: ${props => (props.visible ? "inline-block" : "none")};
  padding: 20px;
  box-sizing: border-box;
  background: inherit;


`;

export const ContentDiv = styled.div`
  background: inherit;
  min-height: 100svh;
  height: auto;
`;

export const HeaderDiv = styled.div`
  background: inherit;
  height: calc(100vw / round(100vw /10px));
`;


export const FilmStrip = styled.div<FilmStripProps>`
  --width: clamp(30px, ${x => x.itemWidth},200px);
  --s: calc(100vw / round(100vw /10px));
  --c: #222;
  --g: ${x => x.gap};
  --count: ${x => x.windowSize};
  --w : ${x => x.windowSize};
  --shift: calc((var(--width) + var(--g)) * var(--count));
  --totalSize: calc((var(--width) + var(--g)) *${x => x.amount}) * 2;

  position: relative;       

  width: var(--totalSize);
  height: var(--width);
  background: conic-gradient(at 50% var(--s), var(--c) 75%, #0000 0) 0 0/calc(2*var(--s)) calc(100% - var(--s)) padding-box;
  
  border: var(--s) solid var(--c);
  padding: calc(var(--s) * 2.5) calc(var(--s) * 1.5);
  box-sizing: content-box;
  will-change: transform;
  transform: translate3d(0, 0, 0);
  display: flex;
  flex-direction: row;
  gap: var(--g);
  align-content: center;
  align-items: center;

  @keyframes scroll {
    from {
      transform: translate3d(0, 0, 0);
    }
    to {
      transform: translate3d(calc(-1 * var(--shift)), 0, 0);
    }
  }
  animation: scroll 5s linear infinite;
`;

export const FilmStripItem = styled.div<FilmStripItemProps>`
  height: 100%;
  border: none;
  width: clamp(30px, ${x => x.itemWidth},200px);

  background: rgba(180, 142, 70, 0.3);
  flex-shrink: 0;
  border-radius: 10px;
`;